import request from "../request";
import { stringify } from "qs";

export function getCompanyList(payload) {
	return request.post({
		url: `/website/enterpriseInfo/searchContact`,
		data: payload,
	});
}

// 企业信息
export function getCompanyInfo(payload) {
	return request.get({
		url: `/website/enterpriseInfo/abstractInfo?${stringify(payload)}`,
	});
}

// 总览
export function getOverView(payload) {
	return request.post({
		url: "/website/enterpriseInfo/overview",
		data: payload,
	});
}

// 趋势分析
export function getTrendAnalysis(payload) {
	return request.post({
		url: "/website/enterpriseInfo/getTradeChart",
		data: payload,
	});
}

// 左图右表
export function getChartAnalysis(payload) {
	return request.post({
		url: "/website/enterpriseInfo/getEnterpriseChart",
		data: payload,
	});
}

// 图下表
export function getAnalysisList(payload) {
	return request.post({
		url: "/website/enterpriseInfo/getEnterpriseList",
		data: payload,
	});
}

// 供应商或采购商趋势
export function getPartnerTrend(payload) {
	return request.post({
		url: "/website/enterpriseInfo/getEnterpriseYears",
		data: payload,
	});
}

// 进口或出口记录列表
export function getTradeRecordList(payload) {
	return request.post({
		url: "/website/enterpriseInfo/tradeList",
		data: payload,
	});
}
